import type { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

// Lazy-load News (only loaded when /news/ is visited)
const News = lazy(() => import("../pages/news/page"));

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#fafafa]">
    <div className="w-10 h-10 border-4 border-[#47d6d4]/20 border-t-[#47d6d4] rounded-full animate-spin"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news/",
    element: (
      <Suspense fallback={<Loading />}>
        <News />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
